import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"sm","breakpoints":{"sm":600,"md":900,"lg":1200,"xl":Infinity}})
